__turbopack_context__.v({
  "image": "ProfilePicture-module__MGq8FG__image",
  "localHeroMark": "ProfilePicture-module__MGq8FG__localHeroMark",
  "offline": "ProfilePicture-module__MGq8FG__offline",
  "online": "ProfilePicture-module__MGq8FG__online",
  "status": "ProfilePicture-module__MGq8FG__status",
});
